"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var core_1 = require("@material-ui/core");
var useStyles = core_1.makeStyles(function () { return ({
    card: {
        minWidth: 275,
        margin: '0 auto',
        marginBottom: 15
    }
}); });
exports.QAPanel = function (_a) {
    var children = _a.children, className = _a.className;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Card, { className: clsx_1.default('faq-panel', className, classes.card), square: true }, children));
};
//# sourceMappingURL=QAPanel.js.map